import { NgModule } from '@angular/core';
import { BaseStoreModule } from '@city/shell';
import { CustomBaseStorefrontModule } from './custom-base-storefront.module';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';
import { SpartacusFeaturesModule } from './spartacus-features.module';

@NgModule({
  imports: [CustomBaseStorefrontModule, SpartacusFeaturesModule, SpartacusConfigurationModule, BaseStoreModule],
  exports: [CustomBaseStorefrontModule, SpartacusFeaturesModule],
})
export class SpartacusModule {}
